import * as actionTypes from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {cloneDeep} from 'lodash';

export default function taskRelatedDocumentsReducer(state = initialstate.aresTaskRelatedDocuments, action) {
	switch (action.type) {
		case actionTypes.GET_TASK_DOCUMENTS: {
			return action.response || state;
		}
		/*case actionTypes.UPDATE_DOCUMENT_ON_ADDING_SIGNOFF: {
			if (state && state.data) {
				let newState = cloneDeep(state);
				let signOff = action.signOff;
				newState.data
					.find((doc) => doc.id === action.documentId)
					.approvals.push({
						approvalUserId: signOff.approvalUserId,
						createDate: signOff.createDate,
						approvalUserName: signOff.name,
						approvalUserInititals: signOff.userInitials,
						isPreparer: signOff.isPreparer,
						clientSignoffJson: signOff.clientSignOffJson,
						hasOverallResponsibility: signOff.hasOverallResponsibility,
						engagementRoleId: signOff.engagementRoleId,
						id: signOff.approvalId
					});
				return newState;
			}
			return state;
		}
		case actionTypes.UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL: {
			if (state && state.data) {
				let newData = cloneDeep(state);
				let removedSignOffId = action.signOff.approvalId;
				newData.data.forEach(function(doc) {
					doc.approvals = doc.approvals.filter((approval) => approval.id !== removedSignOffId);
				});
				return newData;
			}
			return state;
		}*/
		default:
			return state;
	}
}
